import { render, staticRenderFns } from "./portSupplementary.vue?vue&type=template&id=7d895490&scoped=true&"
import script from "./portSupplementary.vue?vue&type=script&lang=js&"
export * from "./portSupplementary.vue?vue&type=script&lang=js&"
import style0 from "./portSupplementary.vue?vue&type=style&index=0&id=7d895490&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d895490",
  null
  
)

export default component.exports